import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Checkbox, Grid, Paper, Tooltip, Typography } from "@material-ui/core";
import { getOppSettlements, updateOppInvoiceMerchants } from "../PaymentProviders/Opp/OppApi";
import CircularProgress from "@material-ui/core/CircularProgress";
import CloseIcon from "@material-ui/icons/Close";
import { Check } from "@material-ui/icons";
import GetCurrency from "../../helper/GetCurrency";
import { withRouter } from "react-router-dom";
import EditTextField from "../EditArticle/EditTextField";

function OppInvoiceMerchant(props) {
  const [settlement, setSettlement] = React.useState(null);
  const [wefactMasterInvoices, setWefactMasterInvoices] = React.useState(
    props.oppInvoiceMerchant?.wefact_master_invoices
  );

  useEffect(() => {
    getOppSettlements(props.match.params.oppMasterMerchantId, props.oppMerchant.uid, 1).then((settlements) => {
      if (
        !settlements.some((settlement) => {
          if (
            settlement.period_start <= parseInt(props.period.getTime() / 1000) &&
            settlement.period_end >= parseInt(props.period.getTime() / 1000) &&
            settlement.period_end - parseInt(props.period.getTime() / 1000) < 3600 * 24 * 7
          ) {
            setSettlement(settlement);
            return true;
          }
          return false;
        })
      ) {
        setSettlement({ number_of_transactions: 0, amount_payable: 0, total_order_fees: 0, number_of_refunds: 0 });
      }
    });
  }, []);

  return (
    <Grid item xs={12}>
      <Paper style={{ padding: 16 }}>
        <Grid container spacing={3}>
          <Grid item xs={3} container>
            {props.loadingOppInvoiceMerchants ? (
              <CircularProgress color="primary" size={18} />
            ) : props.oppInvoiceMerchant == null ? (
              <Tooltip title={"Wefact niet gekoppeld"}>
                <CloseIcon />
              </Tooltip>
            ) : (
              <div>
                <Tooltip title={"Wefact gekoppeld"}>
                  <Check />
                </Tooltip>
                <EditTextField
                  label={"VAT"}
                  value={props.oppInvoiceMerchant.vat_rate_percentage}
                  size={"small"}
                  onBlur={(value, setBeginValue) => {
                    updateOppInvoiceMerchants(
                      props.oppInvoiceMerchant.opp_master_merchant_id,
                      [props.oppInvoiceMerchant],
                      [{ vat_rate_percentage: value }]
                    ).then((oppInvoiceMerchants) => {
                      setBeginValue(oppInvoiceMerchants[0].vat_rate_percentage);
                    });
                  }}
                />
              </div>
            )}
            <Typography variant={"subtitle1"} style={{ flex: "1 1 0%", height: "100%" }}>
              {props.oppMerchant.name}
            </Typography>
          </Grid>
          {settlement == null ? (
            <div align="center">
              <CircularProgress color="primary" size={18} />
            </div>
          ) : (
            <>
              <Grid item xs={3}>
                <Typography variant={"subtitle1"}>{settlement.number_of_transactions}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant={"subtitle1"}>
                  {GetCurrency()} {(settlement.amount_payable / 100.0).toFixed(2)}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant={"subtitle1"}>
                  {GetCurrency()} {(settlement.total_order_fees / 100.0).toFixed(2)}
                  {/*{(settlement.number_of_refunds * 0.2).toFixed(2)}*/}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                {props.oppInvoiceMerchant != null ? (
                  wefactMasterInvoices?.some((invoice) => {
                    return invoice.period === parseInt(props.period.getTime() / 1000);
                  }) ? (
                    <Tooltip title={"Invoiced"} children={<Checkbox disabled={true} checked={true} />} />
                  ) : (
                    <Checkbox
                      checked={props.checked ?? false}
                      onChange={(e) => {
                        if (props.setChecked) {
                          props.setChecked(e.target.checked);
                        }
                      }}
                    />
                  )
                ) : null}
              </Grid>
            </>
          )}
        </Grid>
      </Paper>
    </Grid>
  );
}

OppInvoiceMerchant.propTypes = {
  oppMerchant: PropTypes.object.isRequired,
  period: PropTypes.instanceOf(Date).isRequired,
  oppInvoiceMerchant: PropTypes.object,
  loadingOppInvoiceMerchants: PropTypes.bool.isRequired,
  checked: PropTypes.bool,
  setChecked: PropTypes.func,
};

export default withRouter(OppInvoiceMerchant);
